import { Store as VuexStore, ActionTree, CommitOptions, GetterTree, Module, MutationTree } from "vuex";
import { EncryptState } from "@/store/modules/encrypting/encrypt-state";
import { RootState } from "@/store/root-state";

// initial state
const state: EncryptState = {
  fieldNameToEncryptedValue: new Map<string, string>(),
};

// getters
export type Getters = {
  fieldNameToEncryptedValue(state: EncryptState): Map<string, string>;
};

const getters: GetterTree<EncryptState, RootState> & Getters = {
  fieldNameToEncryptedValue(state: EncryptState): Map<string, string> {
    return state.fieldNameToEncryptedValue;
  },
};

const actions: ActionTree<EncryptState, RootState> = {};

// mutations
export type Mutations = {
  setFieldNameToEncryptedValue(state: EncryptState, payload: Map<string, string>): void;
  addFieldNameToEncryptedValue(state: EncryptState, payload: Map<string, string>): void;
  clearFieldNameToEncryptedValue(state: EncryptState): void;
};

const mutations: MutationTree<EncryptState> & Mutations = {
  setFieldNameToEncryptedValue(state: EncryptState, payload: Map<string, string>): void {
    state.fieldNameToEncryptedValue = payload;
  },
  addFieldNameToEncryptedValue(state: EncryptState, payload: Map<string, string>): void {
    state.fieldNameToEncryptedValue = new Map([...state.fieldNameToEncryptedValue, ...payload]);
  },
  clearFieldNameToEncryptedValue(state: EncryptState): void {
    state.fieldNameToEncryptedValue = new Map<string, string>();
  },
};

// store
export type EncryptStore<S = EncryptState> = Omit<VuexStore<S>, "getters" | "commit" | "dispatch"> & {
  commit<K extends keyof Mutations, P extends Parameters<Mutations[K]>[1]>(
    key: K,
    payload: P,
    options?: CommitOptions
  ): ReturnType<Mutations[K]>;
} & {
  getters: {
    [K in keyof Getters]: ReturnType<Getters[K]>;
  };
};

export const encrypting: Module<EncryptState, RootState> = {
  state,
  getters,
  actions,
  mutations,
};
